"use strict";

const thumbsMediaEl = document.querySelector(".thumbsMedia") // wrapper(s) for display images
const regularMediaEl = document.querySelector(".regularMedia") // wrapper(s) for display images
//console.log(attributeEls)
const cartNotes = document.getElementById("cartNotes")

const productIDEl = document.querySelector("#productID")
const tEntityIDEl = document.querySelector("#tEntityID")
const mediaUrlEl = document.querySelector("#mediaUrl") // only for dynamic products
const mediaIDEl = document.querySelector("#mediaID") // only for dynamic products
const orderQuantityEl = document.querySelector("#orderQuantity")
const cartPriceEl = document.querySelector("#cartPrice")

const sellingPriceEl = document.querySelector(".sellingPrice")
const regularPriceEl = document.querySelector(".regularPrice")

const cardButtonEl = document.querySelector(".cardButton")
const cartDescriptionEl = document.querySelector(".cartDescription")
const quantityEl = document.querySelector(".qty-text")

const jsEntityEl = document.querySelector("#jsEntity")
const jsEntity = JSON.parse(jsEntityEl.value)

let regPrice = 0
let price = 0
let selectedProduct
let cartDescription
let featuredMedia
let media
let productAvailable = true


// find and set as default selected product the IsFeatured one
selectedProduct = jsEntity.Products.filter(item => item.IsFeatured)[0]
updateJsonLD(selectedProduct, jsEntity)
//console.log(selectedProduct)
//console.log(JObject)


let quantity = quantityEl.value

//setAllValues()
updateView()
recalculate()


//quantity.addEventListener("change", setQuantity) does not work. Instead onchange added to the element
function setQuantity() {
    quantity = quantityEl.value
    recalculate()
}

// Update View with media from selected product
function updateView() {
    // display images
    featuredMedia = selectedProduct.ProductMedias.filter(function (item) {
        return item.IsFeatured
    })
    media = selectedProduct.ProductMedias
   
    if (media.length > 0) {
        regularMediaEl.innerHTML = `${media.map(regularMediaTemplate).join("")}`
        thumbsMediaEl.innerHTML = `${media.map(thumbsMediaTemplate).join("")}`
    }
    setupSwiper()
    destroySwiperLoop()
}

// a template for iteration
function thumbsMediaTemplate(md) {
    return `<div class="swiper-slide">
                    <img class="w-100" src="${md.Url}?widthratio=1&height=765&mode=crop" alt="${md.AltText}">
               </div>`
}

// a template for iteration
//<img class="w-100" src="${md.Url}?widthratio=0.785&height=765&mode=crop" alt="${md.AltText}">
function regularMediaTemplate(md) {
    return `<div class="swiper-slide">
                <a class="gallery-link" href="${md.Url}">
                    <img class="w-100" src="${md.Url}?widthratio=1&height=765&mode=crop" alt="${md.AltText}">
                </a>
            </div>`
}

// Recalculate price on user inputs
function recalculate() {
    
    if (selectedProduct.IsInSale) {
        regPrice = selectedProduct.RegularPrice * quantity
        regPrice = (Math.round((regPrice + Number.EPSILON) * 100) / 100).toFixed(2)
        regularPriceEl.innerHTML = `<del>${regPrice} \u20AC</del>`
        sellingPriceEl.dataset.regularprice = selectedProduct.RegularPrice.toFixed(2)
    }
    else {
        regularPriceEl.innerHTML = `<del></del>`
        sellingPriceEl.dataset.regularprice = 0
    }
    price = selectedProduct.SellingPrice * quantity
    price = (Math.round((price + Number.EPSILON) * 100) / 100).toFixed(2)
    //console.log(price)

    sellingPriceEl.innerHTML = price + '\u20AC'
    sellingPriceEl.dataset.price = price
    sellingPriceEl.dataset.sellingprice = selectedProduct.SellingPrice.toFixed(2)
    
    if (price == 0 || price == undefined || isNaN(price) || !productAvailable)
        cardButtonEl.disabled = true
    else
        cardButtonEl.disabled = false
    setAllValues()
}


function setAllValues() {
    productIDEl.value = selectedProduct.ProductID
    tEntityIDEl.value = jsEntity.tEntityID
    var tmp = selectedProduct.ProductMedias.filter(item => item.IsFeatured)[0]
    if (tmp === undefined) {
        mediaUrlEl.value = ""
    }
    else {
        mediaUrlEl.value = `${window.location.protocol}//${window.location.host}${tmp.Url}`
    }
    //mediaUrlEl.value = selectedProduct.ProductMedias.filter(item => item.IsFeatured)[0].Url == undefined ? '' : selectedProduct.ProductMedias.filter(item => item.IsFeatured)[0].Url
    mediaIDEl.value = 0 // only for dynamic products
    orderQuantityEl.value = quantity
    cartPriceEl.value = price
}


